import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { LeaveReasonDetails, LeaveReasonDetailsStore } from '@core/models/leave-reasons/leave-reason-details.model';

@Injectable({
  providedIn: 'root'
})
export class LeaveReasonDetailsStoreService {

  private readonly _initialStoreData: LeaveReasonDetailsStore = {
    leaveReasonDetails: null,
    sysText: null
  };

  private leaveReasonDetailsStore: BehaviorSubject<LeaveReasonDetailsStore>;  
  private store$: Observable<LeaveReasonDetailsStore>;

  private readonly templateNames = {
    leaveReasonDetails: "leaveReasonDetails",
    deleteConfirmation: "deleteConfirmation",
    leavingPage: "leavingPage",
    unsavedChanges: "unsavedChanges",
  };

  constructor() {
    this.leaveReasonDetailsStore = new BehaviorSubject(this._initialStoreData);
    this.store$ = this.leaveReasonDetailsStore.asObservable();
  }

  public get store() {
    return this.leaveReasonDetailsStore.value;
  }

  public get leaveReasonDetails() {
    return this.store.leaveReasonDetails;
  }

  public get sysText() {
    return this.store.sysText;
  }

  public get leaveReasonDetails$(): Observable<LeaveReasonDetails> {
    return this.store$.pipe(pluck('leaveReasonDetails'))
  }

  public get templates() {
    return this.templateNames;
  }

  public set leaveReasonDetails(leaveReasonDetails: LeaveReasonDetails) {
    const store = { ...this.store, leaveReasonDetails};
    this.leaveReasonDetailsStore.next(store);
  }

  public set sysText(sysText: any) {
    const store = { ...this.store, sysText };
    this.leaveReasonDetailsStore.next(store);
  }

  public emailLeaveReasonAssignedToEmployer(leaveReasonDetails: LeaveReasonDetails) {
    this.leaveReasonDetails = leaveReasonDetails;
  }

  public unloadStore() {
    const store: LeaveReasonDetailsStore = {
      leaveReasonDetails: null,
      sysText: null
    }
    this.leaveReasonDetailsStore.next(store)
  }
}